<template>
    <ElDialog
        v-bind="$attrs"
        ref="dialog"
        class="patsnap-biz-dialog"
        v-on="$listeners"
    >
        <template #title>
            <slot name="title">
                <span class="el-dialog__title">{{ title }}</span>
            </slot>
            <PtIcon
                v-if="showClose"
                icon="SolidCloseBig"
                class="patsnap-biz-dialog__close-btn"
                @click="handleClose"
            />
        </template>
        <template #default>
            <slot name="default" />
        </template>
        <template #footer>
            <slot name="footer" />
        </template>
    </ElDialog>
</template>

<script>
import ElDialog from 'element-ui/lib/dialog';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';

export default {
    name: 'PtDialog',
    components: {
        PtIcon,
        ElDialog,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    computed: {
        showClose() {
            return ('showClose' in this.$attrs) ? this.$attrs.showClose : true;
        },
    },
    methods: {
        handleClose() {
            this.$refs.dialog.handleClose();
        },
    },
};
</script>
